<template>
  <div class="d-flex align-center gap-1">
    <v-btn-group density="compact" rounded="lg" variant="outlined">
      <v-tooltip text="Редагувати">
        <template #activator="{ props }">
          <v-btn size="x-small" v-bind="props" @click="openEditDocumentDialog">
            <v-icon color="primary" size="large">mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-tooltip>
      <v-tooltip text="Завантажити протокол підписання">
        <template #activator="{ props }">
          <v-btn size="x-small" v-bind="props" @click="downloadProtocol()">
            <v-icon color="primary" size="large">mdi-file-sign</v-icon>
          </v-btn>
        </template>
      </v-tooltip>

      <v-tooltip text="Завантажити">
        <template #activator="{ props: tooltipProps }">
          <v-menu>
            <template #activator="{ props: menuProps }">
              <v-btn size="x-small" v-bind="{ ...tooltipProps, ...menuProps }">
                <v-icon color="primary" size="large">mdi-upload</v-icon>
              </v-btn>
            </template>

            <b-action-list
              :actions="[
                {
                  title: 'Завантажити архів',
                  action: () => downloadArchive(),
                },
                {
                  title: 'Завантажити P7S',
                  action: () => downloadP7S(),
                },
                {
                  title: 'Завантажити документ',
                  action: () => downloadDocument(),
                },
              ]"></b-action-list>
          </v-menu>
        </template>
      </v-tooltip>

      <v-tooltip text="Друкувати">
        <template #activator="{ props }">
          <v-btn size="x-small" v-bind="props" @click="printDocument()">
            <v-icon color="primary" size="large">mdi-printer</v-icon>
          </v-btn>
        </template>
      </v-tooltip>

      <v-tooltip
        v-if="isAuthor && !documentSignature.relatedDocumentAgreement"
        text="Відправити на візування">
        <template #activator="{ props }">
          <v-btn
            :loading="$loading.isLoading('sendToAgree')"
            size="x-small"
            v-bind="props"
            @click="sendToAgree">
            <v-icon color="primary" size="large">mdi-share</v-icon>
          </v-btn>
        </template>
      </v-tooltip>
      <v-tooltip
        v-if="[1, 2, 4].includes(documentSignature.statusId) && isAuthor"
        text="Видалити">
        <template #activator="{ props }">
          <v-btn
            size="x-small"
            v-bind="props"
            :loading="$loading.isLoading('deleteDocument')"
            @click="deleteDocument">
            <v-icon color="error" size="large">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-tooltip>
    </v-btn-group>
  </div>
</template>

<script lang="ts">
import { useDocumentSignature } from '../index'
import { BActionList } from 'best-modules/components'
import { useCan } from '@/composables/useCan'

export default {
  name: 'Header',
  components: { BActionList },
  setup() {
    const { can } = useCan()
    const printDocument = () => {
      can('document-signatures.print', () => {
        const iframe = window.document.querySelector('iframe')
        if (!iframe) return

        iframe.contentWindow?.focus()
        iframe.contentWindow?.print()
      })
    }

    return { ...useDocumentSignature(), printDocument }
  },
}
</script>

<style scoped lang="scss"></style>
